import { Box, Grid, MenuItem, Paper } from "@material-ui/core";
import DeleteIcon from '@mui/icons-material/Delete';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import ReplyIcon from '@mui/icons-material/Reply';
import { Autocomplete, TextField, useMediaQuery, useTheme } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Fade from '@mui/material/Fade';
import FormControl from "@mui/material/FormControl";
import FormControlLabel from '@mui/material/FormControlLabel';
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import Modal from '@mui/material/Modal';
import OutlinedInput from "@mui/material/OutlinedInput";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from "react-hook-form";
import { FaSearch } from "react-icons/fa";
import { Triangle } from 'react-loader-spinner';
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';
import LoaderBar from "../../components/LoaderBar/LoaderBar";
import PageTitle from "../../components/PageTitle/PageTitle";
import PdfUpload from "../../utils/Uploader/PdfUpload";
import axios from '../../utils/axios';
import Notification from '../login/Notification';
import "./DividendSettlement.css";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#A7C7E7",
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding:0
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));





const DividendSettlement = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  let SubmissionValue = 
  {
    p_id: "",
    p_name: "",
    p_boid: "",
    p_folionumber: "",
    p_nid: "",
    p_passport: "",
    p_accounttype: 2,
    p_sholdername: "",
    p_sholdernid: "",
    p_sholderpassport: "",
    p_settlementdate: "",
    p_totalamount: "",
    p_createdby: "",
    p_updatedby: "",
    p_createdat: "",
    p_updatedat: "",
    p_status: 1,
    p_investordividendtypeid: 0,
    p_applicationdate:"",
    p_claimrecieveddate:"",
    p_settlementserialid:"",
    p_settlementstatus:0,
    p_bank_id:"",
    p_account_no:"",
    p_details:[],
    p_routingno:"",
    p_dp_id:0,
    p_stock_unit_price:0.0,
    isSuspense:0,
    p_dividendstatus:0,
    folio_bo_file:"",
    p_isGroupAmount:0,
    p_claimantname:"",
    p_claimantnid:"",
    mobile_number:"",
    email:"",
    p_totalsuspenseamount:"",
    p_tin:"",
    p_gender:"",

  }
  const { register, reset, handleSubmit,setValue, resetField,control } = useForm();
  

  const onSubmit = data => {
// const settlementButtonActive = submitValue.p_details.length > 0 && submitValue.p_id !== "" && submitValue.p_name !== "" && (submitValue.p_boid !=="" || submitValue.p_folionumber !== "") && 
//                                   submitValue.p_applicationdate !=="" && submitValue.p_claimrecieveddate!=="" && submitValue.p_settlementstatus>0 && submitValue.p_investordividendtypeid>0 &&  
//                                  (submitValue.p_settlementstatus===1 || (submitValue.p_settlementstatus===2 && submitValue.p_settlementserialid!=="" && submitValue.p_settlementdate!=="" && submitValue.folio_bo_file!=="" ))
//                                  && submitValue.mobile_number !== "" ;

const issuerSelectValidation = submitValue.p_id === "" ;
const investorNameValidation = submitValue.p_name === "" ;
const boidFolioValidation = submitValue.p_boid ==="" && submitValue.p_folionumber === "" ;
const settlementDetailsValidation = submitValue.p_details.length === 0 ;
const applicationDateValidation = submitValue.p_applicationdate ==="" ;
const claimRecieveDateValidation = submitValue.p_claimrecieveddate==="";
const settlementStatusValidation = submitValue.p_settlementstatus===0 ;
const dividendTypeValidation = submitValue.p_investordividendtypeid===0 ;
const settlementNoDateValidation = submitValue.p_settlementstatus===2 && (submitValue.p_settlementserialid==="" || submitValue.p_settlementdate==="") ;
const fileUploadValidation = submitValue.folio_bo_file==="";
const mobileNumberValidation = submitValue.mobile_number === "" ;
const genderValidation = submitValue.p_gender === "" ;

const zeroValueYearValidation = submitValue.p_details.find((yearObject) =>yearObject.yearAmount===0 && yearObject.suspenseAmount===0);

const bankInfoRequired = ((submitValue.p_investordividendtypeid === 1 || 
                            submitValue.p_investordividendtypeid === 2 ||
                            submitValue.p_investordividendtypeid === 3 ||
                            submitValue.p_investordividendtypeid === 4 ||
                            submitValue.p_investordividendtypeid === 5 ||
                            submitValue.p_investordividendtypeid === 9
                          ) && (submitValue.p_bankName === "" && submitValue.p_bank_id === "" && submitValue.p_account_no === "") );
const DPInfoRequired = ((submitValue.p_investordividendtypeid < 6 &&  submitValue.p_investordividendtypeid > 8 ) && (submitValue.p_dp_id === "") );
if(issuerSelectValidation)
{
  Swal.fire({
    icon: 'warning',
    title: 'Issuer Required',
    text: 'Please select an Issuer to proceed.',
    showConfirmButton: true,
    // timer: 3000
  })
  return;
}
if(investorNameValidation)
{
  Swal.fire({
    icon: 'warning',
    title: 'Investor Name Required',
    text: 'Please enter Investor Name to proceed.',
    showConfirmButton: true,
    // timer: 3000
  })
  return;
}
if(boidFolioValidation)
{
  Swal.fire({
    icon: 'warning',
    title: 'BOID or Folio No Required',
    text: 'Please enter BOID or Folio No to proceed.',
    showConfirmButton: true,
    // timer: 3000
  })
  return;
}
if(genderValidation)
{
  Swal.fire({
    icon: 'warning',  
    title: 'Gender Required',
    text: 'Please select Gender to proceed.',
    showConfirmButton: true,
    // timer: 3000
  })
  return;
}
if(settlementDetailsValidation)
{
  Swal.fire({
    icon: 'warning',
    title: 'Settlement Details Required',
    text: 'Please add at least one Year & Amount to proceed.',
    showConfirmButton: true,
    // timer: 3000
  })
  return;
}
if(zeroValueYearValidation)
{
  Swal.fire({
    icon: 'warning',
    title: 'Year Amount or Suspense Amount both can not be zero at a time',
    text: 'Please enter a valid amount for all selected years.',
    showConfirmButton: true,  
    // timer: 3000
  })
  return;
}
if(applicationDateValidation)
{
  Swal.fire({
    icon: 'warning',
    title: 'Application Date Required',
    text: 'Please select Application Date to proceed.',
    showConfirmButton: true,
    // timer: 3000
  })
  return;
}
if(claimRecieveDateValidation)
{
  Swal.fire({
    icon: 'warning',
    title: 'Claim Recieve Date Required',
    text: 'Please select Claim Recieve Date to proceed.',
    showConfirmButton: true,
    // timer: 3000
  })
  return;
}
if(settlementStatusValidation)
{
  Swal.fire({
    icon: 'warning',
    title: 'Settlement Status Required',
    text: 'Please select Settlement Status to proceed.',
    showConfirmButton: true,
    // timer: 3000
  })
  return;
}
if(dividendTypeValidation)
{
  Swal.fire({
    icon: 'warning',
    title: 'Dividend Type Required',
    text: 'Please select Dividend Type to proceed.',
    showConfirmButton: true,
    // timer: 3000
  })
  return;
}
if(bankInfoRequired)
{
  Swal.fire({
    icon: 'warning',
    title: 'Bank Information Required',
    text: 'Please fill Bank Name, Branch Name, Bank Account No to proceed.',
    showConfirmButton: true,  
    // timer: 3000
  })
  return;
}
if(DPInfoRequired)
{
  Swal.fire({
    icon: 'warning',
    title: 'DP Information Required',
    text: 'Please fill DP Name to proceed.',
    showConfirmButton: true,  
    // timer: 3000
  })
  return;
}
if(settlementNoDateValidation)
{
  Swal.fire({
    icon: 'warning',
    title: 'Settlement No and Date Required',
    text: 'Please enter Settlement No and Date to proceed.',
    showConfirmButton: true,
    // timer: 3000
  })
  return;
}
if(fileUploadValidation)
{
  Swal.fire({
    icon: 'warning',
    title: 'Settlement File Required',
    text: 'Please upload Settlement File to proceed.',
    showConfirmButton: true,
    // timer: 3000
  })
  return;
}
if(mobileNumberValidation)
{
  Swal.fire({
    icon: 'warning',
    title: 'Mobile Number Required',
    text: 'Please enter Mobile Number to proceed.',
    showConfirmButton: true,
    // timer: 3000
  })
  return;
}







// if(!settlementButtonActive)
// {
  
//   Swal.fire({    
//     icon: 'warning',
//     title: 'You must fill required fields & upload PDF file to settle dividend',
//     text: 'Please fill (Years & Amount, Issuer, Investor Name, BOID or Folio No, Application Date, Claim Recieve Date, Settlement Status, Settlement No, Settlement File).',
//     showConfirmButton: true,
//     // timer: 3000
//   })
//   return;
// }



    setIsLoading(true);
    if(submitValue.p_details.length>0)
    {
      
      let totalAmount = 0;
      let totalSuspenseAmount = 0;
      submitValue.p_details.map((amount)=>{
        totalAmount += amount.amount 
      })
      submitValue.p_details.map((amount)=>{
        totalSuspenseAmount += amount.suspenseAmount 
      })
      // data = {...data,p_details:submitValue.p_details,p_status:1,p_totalAmount:p_totalAmount}
      let newData = []
      newData = {...data,...submitValue,p_totalamount:totalAmount,p_totalsuspenseamount:totalSuspenseAmount}
      
      // console.log("submitValue::",submitValue)
      // console.log("newData::",newData)
      // console.log("totalAmount::",totalAmount)
      delete newData.p_routingNo;
      delete newData.amount;
      delete newData.yearid;

      const fullNumber = newData.mobile_number
        ? `0${newData.mobile_number}`
        : "";

      // console.log(newData);
      const formData = new FormData();
      formData.append("interim",newData.interim);
      formData.append("isSuspense",newData.isSuspense);
      formData.append("p_account_no",newData.p_account_no);
      formData.append("p_accounttype",newData.p_accounttype);
      formData.append("p_applicationdate",newData.p_applicationdate);
      formData.append("p_bankName",newData.p_bankName);
      formData.append("p_bank_id",newData.p_bank_id);
      formData.append("p_boid",newData.p_boid);
      formData.append("p_claimrecieveddate",newData.p_claimrecieveddate);
      formData.append("p_claimtype",newData.p_claimtype);
      formData.append("p_createdat",newData.p_createdat);
      formData.append("p_createdby",newData.p_createdby);
      formData.append("p_details",JSON.stringify(newData.p_details));
      formData.append("p_dividendstatus",newData.p_dividendstatus);
      formData.append("p_dp_id",newData.p_dp_id);
      formData.append("p_folionumber",newData.p_folionumber);
      formData.append("p_id",newData.p_id);
      formData.append("p_investordividendtypeid",newData.p_investordividendtypeid);
      formData.append("p_name",newData.p_name);
      formData.append("p_nid",newData.p_nid);
      formData.append("p_passport",newData.p_passport);
      formData.append("p_remarks",newData.p_remarks);
      formData.append("p_settlementdate",newData.p_settlementdate);
      formData.append("p_settlementserialid",newData.p_settlementserialid);
      formData.append("p_settlementstatus",newData.p_settlementstatus);
      formData.append("p_sholdername",newData.p_sholdername);
      formData.append("p_sholdernid",newData.p_sholdernid);
      formData.append("p_sholderpassport",newData.p_sholderpassport);
      formData.append("p_status",newData.p_status);
      formData.append("p_stock_unit_price",newData.p_stock_unit_price);
      formData.append("p_totalamount",totalAmount);
      formData.append("p_updatedat",newData.p_updatedat);
      formData.append("p_updatedby",newData.p_updatedby);
      formData.append("folio_bo_file",newData.folio_bo_file);
      formData.append("p_isGroupAmount",newData.p_isGroupAmount);
      formData.append("p_claimantname",newData.p_claimantname);
      formData.append("p_claimantnid",newData.p_claimantnid);
      formData.append("mobile_number",fullNumber);
      formData.append("email",newData.email);
      formData.append("p_totalsuspenseamount",totalSuspenseAmount);
      formData.append("p_tin",newData.p_tin);
      formData.append("p_gender",newData.p_gender);

      if(isRemember)
      {
          axios.post('/settlement',formData)
          .then((res)=>{
            if(res.data)
            {
              if(res.data.payload.statusCode === 201)
              {
                setIsLoading(false);
                setValue("yearid",0);
                setSubmitValue(prevState => ({
                  ...prevState,
                  p_details: [],
                }));
                Swal.fire({
                  icon: 'success',
                  title: `${res.data.payload.message}`,
                })
              }
              else if (res.data.payload.statusCode === 409) {
                    setIsLoading(false);

                    const duplicateData = res.data.payload.duplicate_data;

                    const findIssuerName = (issuerId) => {
                      if (!issuerId || !issuerList) return 'N/A';
                      const issuer = issuerList.find(item => item.id === issuerId);
                      return issuer ? issuer.name : issuerId;
                    };

                    let duplicateInfo = '';

                    if (duplicateData && typeof duplicateData === "object") {

                      const formattedFields = Object.entries(duplicateData)
                        .map(([key, value]) => {

                          // Custom handling for specific fields
                          if (key.toLowerCase() === "issuerid") {
                            value = findIssuerName(value);
                          }

                          // Convert camelCase / snake_case to readable label
                          const label = key
                            .replace(/([A-Z])/g, " $1")
                            .replace(/_/g, " ")
                            .replace(/^./, str => str.toUpperCase());

                          return `${label}: ${value ?? ''}`;
                        })
                        .join("<br>");

                      duplicateInfo = `
                        <div style="text-align:left;margin-top:10px;">
                          <strong>Duplicate Details:</strong><br>
                          ${formattedFields}
                        </div>
                      `;
                    }

                    Swal.fire({
                      icon: "warning",
                      title: '⚠ ' + (res.data.payload.message || "Investor Claim Already Exists"),
                      html: duplicateInfo,
                      showConfirmButton: true,
                      confirmButtonColor: "#3085d6",
                      confirmButtonText: "OK"
                    });
                  }
              else
              {
                Swal.fire({
                  icon: 'error',
                  title: res.message,
                  showConfirmButton: true,
                  // timer: 3000
                })
              }
            
            }
            else
            {
              setIsLoading(false);
              Swal.fire({
                icon: 'error',
                title: 'Some Error Occured Please Try Again!',
                showConfirmButton: true
              })
            }
          })
        
            .catch((error)=>
            {
              console.log(error)
              setIsLoading(false);
              Swal.fire({
                icon: 'error',
                title:  `${error}`,
                description:error.message,
                showConfirmButton: true
              });
            })
      }
      
      else
      {

        axios.post('/settlement',formData)
        .then((res)=>{
            if(res.data)
            {
              if(res.data.payload.statusCode === 201)
              {
                // setSelectedBank("0");
                // setAccountTypeId(2);
                // setSelectedClaimType(1);
                getIssuer();
                getDividendTypes();
                // setBankList([]);
                // setDPList([]);
                // setSelectedBranch("0");
                // setSelectedHouse(0);
                // setIsLoading(false);
                setValue("yearid",0);
                setYearId(0);
                setYear("");
                setSubmitValue(SubmissionValue);
                getBankList();
                getdplist();
                DividendYearInterim();
                localStorage.removeItem("savedPDF");
                Swal.fire({
                  icon: 'success',
                  title: `${res.data.payload.message}`,
                  showConfirmButton: true,
                  // timer: 3000
                }).then((res=>{
                  if(res.isConfirmed)
                    window.location.reload();
                }))
                .catch((error)=>{
                  Swal.fire({
                    icon: 'error',
                    title: `${error}`,
                    description:error.message,
                    showConfirmButton: true
                  })
                })
                

                
              }
              else if (res.data.payload.statusCode === 409) {
                    setIsLoading(false);

                    const duplicateData = res.data.payload.duplicate_data;

                    const findIssuerName = (issuerId) => {
                      if (!issuerId || !issuerList) return 'N/A';
                      const issuer = issuerList.find(item => item.id === issuerId);
                      return issuer ? issuer.name : issuerId;
                    };

                    let duplicateInfo = '';

                    if (duplicateData && typeof duplicateData === "object") {

                      const formattedFields = Object.entries(duplicateData)
                        .map(([key, value]) => {

                          // Custom handling for specific fields
                          if (key.toLowerCase() === "issuerid") {
                            value = findIssuerName(value);
                          }

                          // Convert camelCase / snake_case to readable label
                          const label = key
                            .replace(/([A-Z])/g, " $1")
                            .replace(/_/g, " ")
                            .replace(/^./, str => str.toUpperCase());

                          return `${label}: ${value ?? ''}`;
                        })
                        .join("<br>");

                      duplicateInfo = `
                        <div style="text-align:left;margin-top:10px;">
                          <strong>Duplicate Details:</strong><br>
                          ${formattedFields}
                        </div>
                      `;
                    }

                    Swal.fire({
                      icon: "warning",
                      title: '⚠ ' + (res.data.payload.message || "Investor Claim Already Exists"),
                      html: duplicateInfo,
                      showConfirmButton: true,
                      confirmButtonColor: "#3085d6",
                      confirmButtonText: "OK"
                    });
                  }
              else
              {
                Swal.fire({
                  icon: 'error',
                  title: res.message,
                  showConfirmButton: true,
                  // timer: 3000
                })
              }
            
            }
            else
            {
              setIsLoading(false);
              Swal.fire({
                icon: 'error',
                title: 'Some Error Occured Please Try Again!',
                showConfirmButton: true
              })
            }
        })
        
        .catch((error)=>
        {
          setIsLoading(false);
          Swal.fire({
            icon: 'error',
            title: error,
            description:error.message,
            showConfirmButton: true
          })
        })
      }
      //end


      
    }
    else{
      setIsLoading(false);
      setShowError(true);
      
    }
  
  };

let accounts = [{id:1,label:"Joint Account"},{id:2,label:"Individual Account"}] ;
let genderList = [{id:"MALE",label:"MALE"},{id:"FEMALE",label:"FEMALE"},{id:"OTHER",label:"OTHER"}] ;
let claimtypelist =[{id:1,label:"Self"},{id:2,label:"Authorized Person/Power of Attorney"},{id:3,label:"Successor/Nominee"}]; 
let settlementstatus = [{id:1,label:"Ready to settle"},{id:2,label:"Settled"}];
let dividendstatus= [{id:0,label:"Defined"},{id:1,label:"Undefined"},{id:2,label:"Defined Delisted"},{id:3,label:"Undefined Delisted"}] ;
const userID = JSON.parse(localStorage.getItem("user-id"));
const [issuerList,setIssuerList] = useState([]);
  const [dividendType,setDividendType] = useState([]);
  
  const settleyearlist = {yearid:0,amount:0.0,year:""};
  const [year,setYear] = useState("");
  const [yearid,setYearId] = useState(0);
  const [amount,setAmount] = useState(0.0);
  const [submitValue, setSubmitValue] = useState(SubmissionValue);
  const [AccountTypeId, setAccountTypeId] = useState(0);
  const [issuerYear,setIssuerYear] = useState([]);
  const [disabledYears, setDisabledYears] = useState([]);
  const [settlementStatus,setSettlementStatus] = useState(0);
  const [bankList, setBankList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [selectedBank,setSelectedBank] = useState("0");
  const [selectedHouse,setSelectedHouse] = useState(0);
  const [selectedBranch,setSelectedBranch] = useState("0");
  const [InterimList, setInterimList] = useState([]);
  const [selectedInterimYear, setSelectedInterimYear] = useState("FYI");
  const [PrevInterimYear, setPrevInterimYear] = useState("");
  const [selectedDividendType, setSelectedDividendType] = useState("");
  const [open, setOpen] = useState(false);
  const [dpList,setDPList] = useState([]);
  const [showError, setShowError] = useState(false); // Add error state
  const [showAmountError, setShowAmountError] = useState(false); // Add error state
  const [nextId,setNextId] = useState(1);
  const [selectedClaimType,setSelectedClaimType] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [nameLoad,setNameLoad] = useState(false);
  const [InvestorName,setInvestorName] = useState();
  const [InvestorNID,setInvestorNID] = useState();
  const [selectedIssuer,setSelectedIssuer] = useState("");
  const [fileURL,setFileURL] = useState("");
  const [emailError, setEmailError] = useState("");
  const [tinError, setTinError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [BOIDError, setBOIDError] = useState("");
  const [nidError, setNidError] = useState("");
  const [claimnidError, setClaimNidError] = useState("");
  const [sholdernidError,setSholderNidError] = useState("");

  const [isRemember, setIsRemember] = useState(false);

  const [settlementSerial, setSettlementSerial] = useState([]);

  const handleIsRememeber = (event) => {
    setIsRemember(event.target.checked);
  };
  const handleGroupAmount = (e) =>{
    setSubmitValue(prevState => ({
      ...prevState,
      p_isGroupAmount:1,
    }));
  }

// const handleAddSettledYearAmount = () =>{
//   if(yearid===0 || yearid==="" || year==="" || year===null)
//   {
//     setShowError(true);
//     return;
//   }
//   if(amount==="" || amount==="." || isNaN(amount) || Number(amount)<0)
//   {
//     setShowAmountError(true);
//     return;
//   }
//   if(yearid>0 && amount>=0 )
//   {
//     const newEntry = {
//       trackid: nextId, // Assign the next unique ID
//       issuerYeaFormatId: yearid,
//       yearAmount: amount,
//       year: year,
//       status: 1,
//       interimYear: selectedInterimYear,
//       suspenseAmount:0,
      
//       get amount() { return this.yearAmount  + this.suspenseAmount; }
//     };
//     setSubmitValue(prevState => ({
//       ...prevState,
//       p_details: [...prevState.p_details, newEntry],
//     }));
//     setNextId(nextId + 1);
//       setAmount('');
//       setValue('yearid',0);
//       setYearId(0);
//       setYear("");
//       setValue('amount','');
//       setPrevInterimYear(selectedInterimYear);
//   }
//   else
//   {
//     setShowError(true);
//   }
  

// }
const handleAddSettledYearAmount = () => {
  const numericAmount = Number(amount);

  // Year validation
  if (!yearid || yearid === 0 || !year) {
    setShowError(true);
    return;
  }

  // Amount validation
  if (
    amount === "" ||
    amount === "." ||
    isNaN(numericAmount) ||
    numericAmount < 0
  ) {
    setShowAmountError(true);
    return;
  }

  // Now use the CLEAN numeric value
  const newEntry = {
    trackid: nextId,
    issuerYeaFormatId: yearid,
    yearAmount: numericAmount, // store as number, not string
    year: year,
    status: 1,
    interimYear: selectedInterimYear,
    suspenseAmount: 0,

    get amount() {
      return this.yearAmount + this.suspenseAmount;
    },
  };

  setSubmitValue(prevState => ({
    ...prevState,
    p_details: [...prevState.p_details, newEntry],
  }));

  setNextId(prev => prev + 1);

  // Reset properly
  setAmount("0"); // not ""
  setValue("yearid", 0);
  setYearId(0);
  setYear("");
  setValue("amount", "0");
  setPrevInterimYear(selectedInterimYear);
};

const handleDelete = (trackid) => {
  // Filter out the item with the matching trackid

  const updatedDetails = submitValue.p_details.filter(item => item.trackid !== trackid);
  // Update the state with the new array
  setSubmitValue(prevState => ({
    ...prevState,
    p_details: [...updatedDetails]
  }));
};
  const handleChangeAccountType = (event)=>{
   
      setSubmitValue(prevState => ({
        ...prevState,
        p_accounttype: event.target.value,
        p_sholdernid:"",
        p_sholdername:""
      }));
    
    setAccountTypeId(event.target.value);
  }
  const handleChangeSettlementStatus = (event) =>{
    setSubmitValue(prevState => ({
      ...prevState,
      p_settlementstatus:event.target.value,

    }));
    if(event.target.value===1)
    {
      setSubmitValue(prevState => ({
      ...prevState,
       p_settlementserialid:"",
       p_settlementdate: ""
    }));
    }
    setSettlementStatus(event.target.value)
  }

  const handleChangeSuspense = (event) =>{
    setSubmitValue(prevState => ({
      ...prevState,
      isSuspense:event.target.value
    }));
  }
 
  const handleYear = (issueruuid)=>{
    
    if(issueruuid)
    axios.get(`/issuer-year-format/${issueruuid}`)
    .then((res)=>{
      // console.log(res?.data?.payload);
      // res.data.payload.push({id:0,year:"No value Selected"})
      setIssuerYear(res?.data?.payload);
      setSubmitValue(prevState => ({
        ...prevState,
        p_details: []
      }));
      
    })
    .catch((err) =>{
      console.log(err.response.data.message)
    })
    
  }
  const getIssuer = () =>{
    axios.get('./issuer/get-info')
    .then((res)=>{
      setIssuerList(res?.data?.payload);

    })
    .catch((err) =>{
      console.log(err)
    })
  }

  const getDividendTypes = () =>{
    axios.get('/inward-dividend/get-dividend-types')
    .then((res)=>{
      setDividendType(res.data.payload);
    }).catch((err) =>{
      console.log(err.response.data.message)
    })
  }
const getBankList = () =>
{
  axios.get('/bank/get-all-bank-names')
  .then((res)=>{
    // console.log(res.data.payload);
    res.data.payload.map((bank,index)=>{
      bank.label=bank.bankName
      bank.value=bank.bankName
    })

    setBankList(res.data.payload);
  } )
  .catch((err)=>console.log(err));
}
const getdplist = () =>{
  axios.get('/bank/get-all-dp-names')
  .then((res)=>{
    res.data.payload.map((dp,index)=>{
      dp.label=dp.dpName+"("+dp.dpId+")"
      dp.value=dp.id
    })
    setDPList(res.data.payload);
  })
  .catch((err)=>console.log(err));
}
const getBranchList = (bank) =>
  {
    let object = {bankName:`${bank}`}
    axios.post('/bank/get-all-banks-by-name',object)
    .then((res)=>{
      // console.log(res.data.payload);
        // setTimeout(function(){
          res.data.payload.map((branch,index)=>{
            branch.label=branch.branchName
            branch.value=branch.id
          })
          setBranchList(res.data.payload);
          // }, 3000);
      
    } )
    .catch((err)=>{
      console.log(err)
    });
  }

  const getSettlementSerial = (dividendType) =>
  {
    axios.get(`/settlement-no?dividend-type=${dividendType}`)
    .then((res)=>{
      // console.log(res.data.payload);
      setSettlementSerial(res.data.payload);
    })
    .catch((err)=>{
      console.log(err)
    });
  }
  const handleSearchBODetails = () =>{
    if((submitValue.p_boid.length === 16 || submitValue.p_folionumber!== "") && submitValue.p_id!=="")
    {
      setNameLoad(true);

      const searchObject = {boID:submitValue.p_boid,issuer_id:submitValue.p_id,foliono:submitValue.p_folionumber};
      // axios.post('/investor-informations/search',searchObject)
      axios.get(`/settlement/get-investor-name?issuerid=${submitValue.p_id}&boid=${submitValue.p_boid}&folioid=${submitValue.p_folionumber}`)
      .then((res)=>{
        // console.log(res.data)
        if(res.data.payload.investorname)
        {
          setNameLoad(false);
          let loadName = res.data.payload.investorname || "";
          let loadNID = res.data.payload.investornid || "";
          setInvestorName(loadName);
          setInvestorNID(loadNID);
          setSubmitValue(prevState => ({
            ...prevState,
            p_name: loadName,
            p_nid: loadNID
          }));
          
        }
        setNameLoad(false);
      })
      .catch((e)=>{
        setNameLoad(false);
        console.log(e);
      })
    }
    else
    {
      setShowWarning(true);
    }
    
  }
  const DividendYearInterim = () => {
    axios.get('/form-year-type/list')
    .then((res)=>{
      setInterimList(res.data.payload);
    })
  }

//   const getSelectedDpHouse = (boid) => {
//   if (boid && boid.length === 16) {
//     const boidPrefix = boid.substring(3, 8);
//     const filteredDp = dpList.filter(dp => dp.dpId.startsWith(boidPrefix));

//     if (filteredDp.length > 0) {
//       setSubmitValue(prevState => ({
//         ...prevState,
//         p_dp_id: filteredDp[0].id
//       }));
//       setValue("p_dp_id", filteredDp[0].id); // ✅ updates Controller
//     } else {
//       setSubmitValue(prevState => ({
//         ...prevState,
//         p_dp_id: 0
//       }));
//       setValue("p_dp_id", 0); // reset in Controller
//     }
//   } else {
//     setSubmitValue(prevState => ({
//       ...prevState,
//       p_dp_id: 0
//     }));
//     setValue("p_dp_id", 0); // reset in Controller
//   }
// };

const getSelectedDpHouse = (boid) => {
  const boidPrefix = boid.substring(3, 8);
  const match = dpList.find(dp => dp.dpId.startsWith(boidPrefix));
  if (match) {
    setSubmitValue(prev => ({ ...prev, p_dp_id: match.id }));
    setValue("p_dp_id", match.id);
  } else {
    setSubmitValue(prev => ({ ...prev, p_dp_id: 0 }));
    setValue("p_dp_id", "");
  }
};

   const handleFileUploadPDF = (event) => {
      
      const file = event.target.files[0];
      if((file.size/1024)>2096)
      {
        Swal.fire({
          icon: 'warning',
          title: 'The File is greater than 2 MB! ',
          showConfirmButton: true,
          // timer: 3000
        })
        return;
      }
      else
      {
        setFileURL(URL.createObjectURL(file));
        if (file.type === "application/pdf" ) 
          {
            setSubmitValue( prevValues => {
              return { ...prevValues,folio_bo_file: file}
            })
            setOpen(true); 
        }
        else
        {
          Swal.fire({
            icon: 'warning',
            title: 'File does not support. You must use .pdf ',
            showConfirmButton: true,
            // timer: 3000
          })
          return;
        }
      }
      
      
      
    };
    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '60%',
      height:"80vh",
      bgcolor: 'background.paper',
      border: '2px solid #eee',
      boxShadow: '2px 2px 2px 2px #eee',
      borderRadius:"10px",
      p: 4
    };
    const handleOpenPreview = () =>{
      return(
        <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={()=>setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        slots={{ backdrop: Backdrop }}
        slotProps={{
        backdrop: {
            timeout: 500,
        }}}
       style={{maxHeight: "90vh",  overflow: "auto", textAlign:"center", borderRadius:"10px"
       }}
       >
        <Fade in={open}>
        <Box sx={style} style={{textAlign:"center",width:"80%"}} >
            <h3>PDF PREVIEWER </h3>
            
            
            
            <Box className="form-control" style={{textAlign:"center",height:"90%"}}>
                {fileURL ? (
                    // <div
                    //     style={{
                    //         border: '1px solid rgba(0, 0, 0, 0.3)',
                    //         height: '100%',
                    //     }}
                    // >
                    //     <Viewer fileUrl={fileURL} />
                    // </div>
                    <iframe
                        src={fileURL}
                        width="100%"
                        height="100%"
                        title="PDF Viewer"
                      />
                ) : (
                    <div
                        style={{
                            alignItems: 'center',
                            border: '2px dashed rgba(0, 0, 0, .3)',
                            display: 'flex',
                            fontSize: '2rem',
                            height: '100%',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        Preview area
                    </div>
                )}
                
                <Button type="button" onClick={()=>setOpen(false)} variant="contained" color="info" style={{color:"white"}}><ReplyIcon/> Go Back</Button>
                </Box>

                
             
        </Box>
        </Fade>
    </Modal>
      )
    }
  useEffect(() => {
    getIssuer();
    getDividendTypes();
    getBankList();
    getdplist();
    DividendYearInterim();
  }, [])
  useEffect(() => {
  if (
    selectedDividendType === "Stock" &&
    submitValue.p_boid &&
    submitValue.p_boid.length === 16 &&
    dpList.length > 0
  ) {
    getSelectedDpHouse(submitValue.p_boid);
  }
  if(submitValue.p_boid ==="" || selectedDividendType !== "Stock")
  {
    setSubmitValue(prev => ({ ...prev, p_dp_id: 0 }));
    setValue("p_dp_id", "");
  }
}, [submitValue.p_boid, selectedDividendType, dpList]);

  return (
    <React.Fragment style={{ padding: "20px", textAlign:"center", width: "80vw",margin:"10px" }}>
      <PageTitle title={"Initial Dividend Settlement Entry"}></PageTitle>
    {
      isLoading
      ?
            <LoaderBar/>
        :
      <Grid container spacing={2} style={{textAlign:"center"}}>
    <form fullWidth onSubmit={handleSubmit(onSubmit)} onKeyDown={(e)=>{if(e.key === "Enter")e.preventDefault();}} >
    <Grid container spacing={2} >
    <Grid item xs={12} md={12} style={{margin:"10px 50px 10px 50px",boxShadow:"2px 2px 2px 2px gray",padding:"20px",border:"2px solid slateblue",borderRadius:"5px"}}>
      <div style={{marginBottom:"5px",textAlign:"left",color:"slateblue"}}><h2>Personal Information</h2></div>
      <div style={{marginBottom:"5px"}}>
      <Controller
                      name="p_id"
                      control={control}
                      render={({ field, fieldState: { error } }) => {
                        const { onChange, value, ref } = field;
                        return (
                          <>
                            <Autocomplete
                                value={
                                  value
                                    ? issuerList.find((option) => option.id === value) ?? null
                                    : null
                                }
                                disableClearable
                                getOptionLabel={(option) => `${option.name} (${option.tradecode})`}
                                onChange={(event, data) => {
                                  // Update form value using onChange
                                  onChange(data ? data.id : "");  // Update value for Controller

                                  // Update the state with additional fields
                                  if (data) {
                                    setSubmitValue((prevState) => ({
                                      ...prevState,
                                      p_id: data.id
                                      
                                    }));
                                    handleYear(data.id);
                                    setSelectedIssuer(data.id);
                                  } else {
                                    setSubmitValue((prevState) => ({
                                      ...prevState,
                                      p_id: ""
                                      
                                    }));
                                  }
                                }}
                                options={issuerList}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={"Select Issuer"}
                                    inputRef={ref}
                                    required
                                  />
                                )}
                              />
                            {submitValue.p_id === "" && (
                              <span style={{ color: "red" }}>Issuer ID required</span>
                            )}
                          </>
                        );
                      }}
                    />
        </div>
        <div style={{marginBottom:"5px",textAlign:"center"}}>
        <Grid container spacing ={2}>
        <Grid item lg={6} md={6} sm={12} xs={12} >
          <TextField
              fullWidth
              variant="outlined"
              id="boidinput"
              type="text" // ⚠️ Use text instead of number to avoid scientific notation and unwanted leading zeros
              label="BOID"
              style={{ margin: "5px 0" }}
              value={submitValue.p_boid || ""}
              onChange={(e) => {
                let value = e.target.value.replace(/\D/g, ""); // Allow only digits

                // Max 16 digits
                if (value.length > 16) {
                  value = value.slice(0, 16);
                }

                setSubmitValue((prevState) => ({
                  ...prevState,
                  p_boid: value,
                }));

                // Validation
                if (value && value.length !== 16) {
                  setBOIDError("BOID must be exactly 16 digits");
                } else {
                  setBOIDError("");
                }
              }}
              onWheel={(e) => e.target.blur()} // Disable scroll number input
              onKeyDown={(e) => {
                if (["ArrowUp", "ArrowDown", "e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault(); // Disable invalid characters
                }
              }}
              inputProps={{
                inputMode: "numeric", // Show numeric keyboard on mobile
                pattern: "\\d*",
                maxLength: 16,
              }}
              error={!!BOIDError}
              helperText={BOIDError && <span style={{ color: "red" }}>{BOIDError}</span>}
            />
                  
      </Grid>
    <Grid item lg={6} md={6} sm={12} xs={12} >
      <TextField 
      name="p_folionumber"
      fullWidth 
      variant="outlined" 
      type="text" 
      label="Folio No" 
      style={{ margin: "5px 0", width: "100%" }}
      value= {submitValue.p_folionumber}
      {...register("p_folionumber")}
      onChange={(e)=>{
        setSubmitValue(prevState => ({
          ...prevState,
          p_folionumber: e.target.value
        }));
      }}
      
       />
</Grid></Grid>
<Tooltip title="Search if investor Exists"> 
                  <Button variant="contained" color="primary"  style={{padding:"10px",fontSize:"12px"}} onClick={handleSearchBODetails}><FaSearch/>&nbsp; Search Name by BOID / FolioNo</Button>
                  </Tooltip>
                  {showWarning && (
        <Notification message={"Please enter Issuer Name and BOID(16 Digit) / Folio No"} open={true} handleClose={()=>setShowWarning(false)} color='red' />
      )}
      </div>
      <Grid container spacing ={2}>
        {
          nameLoad 
          ?
          <Grid item lg={4} md={4} sm={12} xs={12}>
          <div style={{display: "flex", justifyContent: "center", alignItems: "center",}}>
            
                          <Triangle
                            visible={true}
                            height="60"
                            width="60"
                            color="#0275d8"
                            textAlign="center"
                            // wrapperStyle={{ padding: 'auto auto'}}
                            style={{zIndex:2000}}
                            ariaLabel="triangle-loading"
                            wrapperClass=""
                            />
                            </div>
                            </Grid>
                            :
                            <Grid item  lg={4} md={4} sm={12} xs={12}>
                            <TextField
                            // {...register("p_name")}
                            required 
                            fullWidth variant="outlined" type="text" name="p_name" 
                              id="outlined-controlled"
                              label="Name"
                              value={InvestorName}
                              style={{ margin: "5px 0", width: "100%" }}
                              onChange={(event) => {
                                setInvestorName(event.target.value);
                                setSubmitValue(prevState => ({
                                        ...prevState,
                                        p_name: event.target.value
                                      }));
                              }}
                              
                            />
                            {submitValue.p_name === "" && (
                                <span style={{ color: "red" }}>Name required</span>
                              )}
                            </Grid>

        }

        <Grid item lg={4} md={4} sm={12} xs={12} >
          <FormControl fullWidth style={{margin: "5px 0", width: "100%"}} required variant="outlined" >
            <InputLabel htmlFor="mobile_number">Mobile Number</InputLabel>
              <OutlinedInput
                id="mobile_number"
                name="mobile_number"
                required
                type="text"
                value={submitValue.mobile_number}
                {...register("mobile_number")}
                onChange={(e) => {
                  let value = e.target.value.replace(/\D/g, ""); // digits only

                  // Strip leading 0 if user types 01...
                  if (value.startsWith("0")) {
                    value = value.slice(1);
                  }

                  // Max 10 digits after +880
                  if (value.length > 10) {
                    value = value.slice(0, 10);
                  }
                  let formattedValue = `${value}`
                  setSubmitValue((prev) => ({
                    ...prev,
                    mobile_number: formattedValue,
                  }));
                   // Validation
                      if (value.length !== 10) {
                        setMobileError("Mobile No. must be 11 digits!");
                      } else {
                        setMobileError("");
                      }
                }}
                
                startAdornment={
                  <InputAdornment position="start">+880</InputAdornment>
                }
                placeholder="1XXXXXXXXX"
                inputProps={{
                  maxLength: 10, // restrict typing length
                }}
                label="Mobile Number"
              />
              {
                submitValue.mobile_number === "" 
                                  ? 
                                    (
                                      <span style={{ color: "red" }}>Mobile No. required</span>
                                    ) 
                                    : 
                                    mobileError 
                                    ? 
                                    (
                                      <span style={{ color: "red" }}>{mobileError}</span>
                                    ) 
                                    : 
                                    null
              }
            </FormControl>
        


        </Grid>
        <Grid item  lg={4} md={4} sm={12} xs={12}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              type="email"
                              name="email"
                              id="outlined-controlled"
                              label="Email"
                              value={submitValue.email}
                              style={{ margin: "5px 0", width: "100%" }}
                              onChange={(event) => {
                                const value = event.target.value;
                                setSubmitValue((prev) => ({ ...prev, email: value }));

                                // Validate email format
                                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                if (value && !emailRegex.test(value)) {
                                  setEmailError("Please enter a valid email address");
                                } else {
                                  setEmailError("");
                                }
                              }}
                            />

                            {/* Validation messages */}
                            {
                            // submitValue.email === "" ? (
                            //   <span style={{ color: "red" }}>Email required</span>
                            // ) : 
                            emailError ? (
                              <span style={{ color: "red" }}>{emailError}</span>
                            ) : null}

                            </Grid>
      </Grid>
      <Grid container spacing ={3}> 

        {
          nameLoad ? (
            <Grid item lg={4} md={4} sm={12} xs={12}>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Triangle
                  visible={true}
                  height="60"
                  width="60"
                  color="#0275d8"
                  ariaLabel="triangle-loading"
                  style={{ zIndex: 2000 }}
                />
              </div>
            </Grid>
          ) : (
            <Grid item lg={4} md={4} sm={12} xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                type="text"
                name="p_nid"
                label="NID"
                style={{ margin: "5px 0", width: "100%" }}
                value={InvestorNID}
                onChange={(e) => {
                  let value = e.target.value.replace(/\D/g, ""); // digits only

                  // Limit to 17 digits
                  if (value.length > 17) {
                    value = value.slice(0, 17);
                  }

                  setInvestorNID(value);
                  setSubmitValue((prevState) => ({
                    ...prevState,
                    p_nid: value,
                  }));

                  // Validate
                   if (value && ![10, 13, 17].includes(value.length)) {
                    setNidError("NID must be 10, 13, or 17 digits");
                  } else {
                    setNidError("");
                  }
                }}
                inputProps={{
                  inputMode: "numeric", // mobile numeric keyboard
                  pattern: "\\d*",
                  maxLength: 17,
                }}
                error={!!nidError}
                helperText={nidError && <span style={{ color: "red" }}>{nidError}</span>}
              />
            </Grid>
          )
        }

      <Grid item lg={4} md={4} sm={12} xs={12} >
      <TextField fullWidth variant="outlined" type="text" name="p_passport" value={submitValue.p_passport} label="Passport" style={{ margin: "5px 0", width: "100%" }}
      onChange={(e)=>{
        setSubmitValue(prevState => ({
          ...prevState,
          p_passport: e.target.value
        }));
      }}
      
      />
      </Grid>
      <Grid item  lg={4} md={4} sm={12} xs={12} >
            <TextField
              fullWidth
              variant="outlined"
              type="text"
              name="p_tin"
              label="TIN"
              value={submitValue.p_tin}
              style={{ margin: "5px 0", width: "100%" }}
              onChange={(e) => {
                const value = e.target.value;

                // Allow only numbers
                if (/^\d*$/.test(value)) {
                  setSubmitValue((prevState) => ({
                    ...prevState,
                    p_tin: value,
                  }));

                  // Validation: must be exactly 12 digits
                  if (value && value.length !== 12) {
                    setTinError("12 Digit TIN No. is required!");
                  } else {
                    setTinError("");
                  }
                }
              }}
              error={!!tinError} // MUI red border when invalid
              helperText={tinError} // inline validation text
              inputProps={{ maxLength: 12 }} // prevents typing more than 12 digits
            />
      </Grid>
      </Grid>
      <Grid container spacing ={2}>
      <Grid item lg={4} md={4} sm={12} xs={12} >
              <TextField
                    select
                    fullWidth
                    required
                    name="p_claimtype"
                    
                    defaultValue={selectedClaimType}
                    {...register("p_claimtype", { required: true })}
                    label="Select Claim Type"
                    variant="outlined"
                    className="input-field"
                    onChange={(e)=>{
                      if(e.target.value==1)
                      {
                        setSubmitValue(prevState => ({
                          ...prevState,
                          p_claimtype: e.target.value,
                          p_claimantname:"",
                          p_claimantnid:"",
                        }));
                      }
                          
                        else{
                          setSubmitValue(prevState => ({
                            ...prevState,
                            p_claimtype: e.target.value,
                          }));
                        }
                      
                      setSelectedClaimType(e.target.value)
                    }}
                    style={{ margin: "5px 0", width: "100%" }}
                  >
                    {claimtypelist.map((option, index) => (
                      <MenuItem
                        key={index}
                        value={option.id}
                        style={{ fontSize: 13,fontWeight:"bold" }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
              </TextField> 
              </Grid>

    <Grid item lg={4} md={4} sm={12} xs={12} >
<Tooltip title={<><strong>Defined -</strong> Investor List against this dividend is Available<br></br>
                    <strong>Undefined </strong>- Investor List against this dividend is NOT Available<br></br>
                    <strong>Defined Delisted </strong>- The Company is now Delisted and Investor List against this dividend is Available<br></br>
                    <strong>Undefined Delisted</strong> -  The Company is now Delisted and Investor List against this dividend is NOT Available<br></br></>}> 
    <TextField
                    select
                    fullWidth
                    required
                    
                    name="p_dividendstatus"
                    {...register("p_dividendstatus", { required: true })}
                    label="Select Dividend Status"
                    variant="outlined"
                    className="input-field"
                    defaultValue={0}
                    onChange={(e)=>{
                      setSubmitValue(prevState => ({
                        ...prevState,
                        p_dividendstatus: e.target.value
                      }));
                    }}
                    style={{ margin: "3px 0px 3px 0px" }}
                  >
                    {dividendstatus.map((option, index) => (
                      <MenuItem
                        key={index}
                        value={option.id}
                        style={{ fontSize: 13,fontWeight:"bold" }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
              </TextField>
              </Tooltip>
              </Grid>
              <Grid item lg={4} md={4} sm={12} xs={12} >
                    <TextField
                    select
                    fullWidth
                    required
                    
                    name="p_gender"
                    {...register("p_gender", { required: true })}
                    label="Select Gender"
                    variant="outlined"
                    className="input-field"
                    onChange={(e)=>{
                      setSubmitValue(prevState => ({
                        ...prevState,
                        p_gender: e.target.value
                      }));
                    }}
                    style={{ margin: "3px 0px 3px 0px" }}
                  >
                    {genderList.map((option, index) => (
                      <MenuItem
                        key={index}
                        value={option.id}
                        style={{ fontSize: 13,fontWeight:"bold" }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
              </TextField>
              {submitValue.p_gender === "" && (
                              <span style={{ color: "red" }}>Gender required</span>
                            )}
              </Grid>

              </Grid>
              {
                selectedClaimType == 2
                ?
                <>
                <Grid container spacing ={2}>
                <Grid item lg={6} md={6} sm={12} xs={12} >
                  <TextField
                          fullWidth
                          variant="outlined"
                          type="text"
                          name="p_claimantname"
                          value={submitValue.p_claimantname}
                          label="Authorized / Power of Attorney Name"
                          style={{ margin: "5px 0", width: "100%" }}
                          onChange={(e) =>
                            setSubmitValue((prev) => ({
                              ...prev,
                              p_claimantname: e.target.value,
                            }))
                          }
/>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12} >
                  <TextField
                fullWidth
                variant="outlined"
                type="text"
                name="p_claimantnid"
                label="Authorized / Power of Attorney NID"
                style={{ margin: "5px 0", width: "100%" }}
                value={submitValue.p_claimantnid}
                onChange={(e) => {
                  let value = e.target.value.replace(/\D/g, ""); // digits only

                  // Limit to 17 digits
                  if (value.length > 17) {
                    value = value.slice(0, 17);
                  }
                  setSubmitValue((prevState) => ({
                    ...prevState,
                    p_claimantnid: value,
                  }));

                  // Validate
                   if (value && ![10, 13, 17].includes(value.length)) {
                    setClaimNidError("NID must be 10, 13, or 17 digits");
                  } else {
                    setClaimNidError("");
                  }
                }}
                inputProps={{
                  inputMode: "numeric", // mobile numeric keyboard
                  pattern: "\\d*",
                  maxLength: 17,
                }}
                error={!!claimnidError}
                helperText={claimnidError && <span style={{ color: "red" }}>{claimnidError}</span>}
              />

                  </Grid></Grid>
                </>
                :
                selectedClaimType == 3
                ?
                <>
                <Grid container spacing ={2}>
                <Grid item lg={6} md={6} sm={12} xs={12} >
                    <TextField fullWidth variant="outlined" type="text"  name="p_claimantname" value={submitValue.p_claimantname} label="Successor / Nominee Name"  style={{ margin: "5px 0", width: "100%" }}
                    onChange={(e)=>{
                      setSubmitValue(prevState => ({
                        ...prevState,
                        p_claimantname : e.target.value
                      }));
                    }} />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12} >
                    <TextField
                fullWidth
                variant="outlined"
                type="text"
                name="p_claimantnid"
                label="Successor / Nominee NID"
                style={{ margin: "5px 0", width: "100%" }}
                value={submitValue.p_claimantnid}
                onChange={(e) => {
                  let value = e.target.value.replace(/\D/g, ""); // digits only

                  // Limit to 17 digits
                  if (value.length > 17) {
                    value = value.slice(0, 17);
                  }
                  setSubmitValue((prevState) => ({
                    ...prevState,
                    p_claimantnid: value,
                  }));

                  // Validate
                   if (value && ![10, 13, 17].includes(value.length)) {
                    setClaimNidError("NID must be 10, 13, or 17 digits");
                  } else {
                    setClaimNidError("");
                  }
                }}
                inputProps={{
                  inputMode: "numeric", // mobile numeric keyboard
                  pattern: "\\d*",
                  maxLength: 17,
                }}
                error={!!claimnidError}
                helperText={claimnidError && <span style={{ color: "red" }}>{claimnidError}</span>}
              />
                    </Grid></Grid>
                </>
                :
                null
              }
     
      

              {/* <div
                  style={{
                    border: '3px solid black',
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '16px',
                    margin: '35px auto',
                    padding:"10px"
                  }}
                  >
                    <strong style={{color:'blue'}}>Dividend Status Explanation</strong><br></br>
                    <strong>Defined -</strong> Investor List against this dividend is Available<br></br>
                    <strong>Undefined </strong>- Investor List against this dividend is NOT Available<br></br>
                    <strong>Defined Delisted </strong>- The Company is now Delisted and Investor List against this dividend is Available<br></br>
                    <strong>Undefined Delisted</strong> -  The Company is now Delisted and Investor List against this dividend is NOT Available<br></br>
            
                </div>   */}
      

      
      </Grid>

      {
            submitValue.p_id !== ""
            ?
            <Grid item xs={12} md={12} style={{margin:"10px 50px 10px 50px" ,padding:"20px",boxShadow:"2px 2px 2px 2px gray" ,border:"2px solid slateblue",borderRadius:"5px"}}>
              <div style={{marginBottom:"5px",textAlign:"left",color:"slateblue"}}><h2>Dividend Details</h2></div>
    <Box
          component="form"
          sx={{
            '& > :not(style)': { m: 1, width: '100%' }, // Full width on small screens
          }}
          noValidate
          autoComplete="off"
          style={{ textAlign: 'center',margin:"20px"}}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault(); // Prevent form submission
              handleAddSettledYearAmount(); // Custom handler
            }
          }}
        >
          <Grid container spacing={3} >
            <Grid item xs={12} md={12} lg={4}>
              {
                submitValue.p_id === ""
                ?
                (<h4 style={{color:"red",textAlign:"center"}}>Select Issuer Name</h4>)
                :
                (
                issuerYear.length > 0
                ?
                <>
            {/* <Controller
                name="yearid"
                control={control}
                render={({ field: { onChange, value } }) => (
              <TextField
                select
                fullWidth
                name="yearid"
                value={value}
                label="Select Year before"
                variant="outlined"
                className="input-field"
                style={{ margin: "0 15px" }}
                onChange={(event, newValue) => {
                  onChange(event.target.value);
                  setYearId(event.target.value);
                  console.log(newValue," newvalue");
                  setYear(newValue.props.children);
                }}
              >
                {issuerYear?.map((option, index) => (
                  <MenuItem
                    key={index}
                    value={option.id}
                    // disabled = {disabledYears.includes(option.id)}
                    style={{ fontSize: 13, fontWeight: "bold" }}
                  >
                    {option.year}
                  </MenuItem>
                )
                )}
              </TextField>
                )}/> */}
            <Controller
                            name="yearid"
                            control={control}
                            render={({ field, fieldState: { error } }) => {
                              const { onChange, value, ref } = field;
                              return (
                                <>
                                  <Autocomplete
                                      value={
                                        value
                                          ? issuerYear.find((option) => option.id === value) ?? null
                                          : null
                                      }
                                      getOptionLabel={(option) => `${option.year}` || ""} // Use the correct key (bankName) for display
                                      onChange={(event, data) => {
                                        // Update form value using onChange
                                        onChange(data ? data.id : "");  // Update value for Controller
                                        
                                        // Update the state with additional fields
                                        if (data) {
                                          setYearId(data.id);
                                          setYear(data.year);
                                        }
                                      }}
                                      options={issuerYear}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={"Select Year"}
                                          style={{  width: "100%",margin: "0 15px" }}
                                          
                                          inputRef={ref}
                                          error={!!error}
                                          helperText={error ? error.message : ""}
                                        />
                                      )}
                                    />
                                </>
                          
                              );
                            }}
                          />
                          </>
              :
              // <TextField style={{color:"red",textAlign:"center"}} fullWidth label=" Issuer Name not selected / Issuer year not defined"  disabled/>
              <h4 style={{color:"red",textAlign:"center"}}> <Link to="/app/issuer/yearDefine">Define Issuer Year</Link></h4>)
              }
            </Grid>

            <Grid item xs={12} md={12} lg={4}>
            <Controller
                name="interim"
                control={control}
                render={({ field: { onChange, value } }) => (
              <TextField
                select
                fullWidth
                name="interim"
                
                value={value}
                defaultValue= {"FYI"}
                label="Select Interim Year"
                variant="outlined"
                className="input-field"
                style={{ margin: "0 15px" }}
                onChange={(event, newValue) => {
                  onChange(event.target.value);
                  setSelectedInterimYear(event.target.value);
                }}
              >
                {InterimList?.map((option, index) => (
                  <MenuItem
                    key={index}
                    value={option.name}
                    style={{ fontSize: 13, fontWeight: "bold" }}
                  >
                    {option.description + ' ('+option.name+ ') '}
                  </MenuItem>
                )
                )}
              </TextField>
                )}/>
              
            </Grid>

            {/* <Grid item xs={12} md={12} lg={4}>
             <Controller
                name="amount"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    fullWidth
                    variant="outlined"
                    type="number"
                    
                    InputProps={{ inputProps: { min: 0} }}
                    value={amount}
                    onChange={(event) => {
                      const numericValue = Number(event.target.value);
                      onChange(numericValue);
                      setAmount(numericValue);

                  }
                  }
                    label="Cash Amount / Stock Amount"
                    style={{ margin: "0 15px" }}
                  />
                )}
              />
            </Grid> */}
            <Grid item xs={12} md={12} lg={4}>
            <Controller
              name="amount"
              control={control}
              defaultValue="0"
              render={({ field: { onChange, value } }) => (
                <TextField
                  fullWidth
                  variant="outlined"
                  type="text" // IMPORTANT: not "number"
                  value={value}
                  onChange={(event) => {
                    let val = event.target.value;
                    // Allow only digits and one dot
                    if (!/^\d*\.?\d*$/.test(val)) return;

                    // Remove leading zeros (but keep "0." case)
                    if (val.startsWith("0") && val.length > 1 && !val.startsWith("0.")) {
                      val = val.replace(/^0+/, "");
                    }

                    // If user types ".5" → convert to "0.5"
                    if (val.startsWith(".")) {
                      val = "0" + val;
                    }

                    onChange(val);
                    setAmount(val);
                  }}
                  label="Cash Amount / Stock Amount"
                  style={{ margin: "0 15px" }}
                />
              )}
            />
            </Grid>

            <Grid item xs={12} md={12} >
            <div>
              <FormControlLabel control={<Checkbox defaultChecked={submitValue.p_isGroupAmount} onChange={handleGroupAmount}/>} label="Is Group Amount?"/>

            </div>
              <Button
                variant="contained"
                color='info'
                style={{color: "white" , padding:"10px",backgroundColor:"slateblue"}}
                onClick={handleAddSettledYearAmount}

              >
                <PlaylistAddIcon /> &nbsp; &nbsp;Add
              </Button>
            </Grid>
          </Grid>
        </Box>
        {showError && (
        <Notification message={"Please enter the dividend year and amount"} open={true} handleClose={()=>setShowError(false)} color='red' />
      )}
      {showAmountError && (
        <Notification message={"Please enter a valid amount"} open={true} handleClose={()=>setShowAmountError(false)} color='red' />
      )}
        {
                submitValue.p_details.length> 0 
                ?
                <Paper style={{ margin:"10px 50px 10px 50px",padding:0,boxShadow:"2px 2px 2px 2px gray",justifyContent:"center"}} container spacing={2} >
                <TableContainer component={Paper} sx={{ width: '100%',maxHeight: 440}}>
              <Table sx={{ minWidth: 700 }} stickyHeader aria-label="simple table">
                <TableHead >
                  <TableRow>
                    <StyledTableCell align="center"  style={{fontSize:"1rem"}}>Year</StyledTableCell>
                    <StyledTableCell align="center"  style={{fontSize:"1rem"}}>Interim</StyledTableCell>
                    <StyledTableCell align="center"  style={{fontSize:"1rem"}}>Cash / Stock</StyledTableCell>
                    
                        <StyledTableCell align="center" style={{fontSize:"1rem"}}>Suspense Amount</StyledTableCell>
                        
                      <StyledTableCell align="center" style={{fontSize:"1rem"}}>Total Amount</StyledTableCell> 
                    
                    <StyledTableCell align="center"   colSpan={2} style={{fontSize:"1rem"}}> Delete</StyledTableCell>
                    {/* <StyledTableCell align="center" style={{fontSize:"1rem"}}></StyledTableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody style={{overflow:"hidden",maxHeight:440}}>
                  {submitValue.p_details.toReversed().map((row) => (
                    <StyledTableRow key={row.trackid}>
                      <StyledTableCell align="center">{row.year}</StyledTableCell>
                      <StyledTableCell align="center">{row.interimYear}</StyledTableCell>
                      <StyledTableCell align="center">{row.yearAmount}</StyledTableCell>
                      <StyledTableCell align="center">
        
                        {/* <TextField
                        style={{margin:"2px",width:"40%",justifyContent:"center"}}
                        size="small"
                        InputProps={{ inputProps: { min: 0,step: "any",} }}
                          value={row.suspenseAmount}
                          onChange={(e) => {
                            const suspenseAmt = Number(e.target.value);
                            setSubmitValue(prev => ({
                              ...prev,
                              p_details: prev.p_details.map(item =>
                                item.trackid === row.trackid
                                  ? {
                                      ...item,
                                      suspenseAmount: suspenseAmt,
                                      amount: item.yearAmount + suspenseAmt,
                                    }
                                  : item
                              )
                            }));
                          }}
                          type="number"
                        /> */}
                        <TextField
                            style={{ margin: "2px", width: "40%", justifyContent: "center" }}
                            size="small"
                            type="text"
                            InputProps={{
                              inputProps: {
                                min: 0,
                                step: "any",
                              },
                            }}
                            value={row.suspenseAmount}
                            onChange={(e) => {
                              let val = e.target.value;

                              // Allow only digits and one dot
                              if (!/^\d*\.?\d*$/.test(val)) return;

                              // Remove leading zeros except 0.xxx
                              if (
                                val.startsWith("0") &&
                                val.length > 1 &&
                                !val.startsWith("0.")
                              ) {
                                val = val.replace(/^0+/, "");
                              }

                              // ".5" -> "0.5"
                              if (val.startsWith(".")) {
                                val = "0" + val;
                              }

                              const suspenseAmt = Number(val || 0);

                              setSubmitValue((prev) => ({
                                ...prev,
                                p_details: prev.p_details.map((item) =>
                                  item.trackid === row.trackid
                                    ? {
                                        ...item,
                                        suspenseAmount: val,
                                        amount: item.yearAmount + suspenseAmt,
                                      }
                                    : item
                                ),
                              }));
                            }}
                          />
      
    </StyledTableCell> 
                      
     <StyledTableCell align="center" style={{fontSize:12}}>
      {row.amount}
      </StyledTableCell>
     
                      <StyledTableCell align="center" ><Button style={{margin:"2px"}}  variant="outlined" size="small" color="error" onClick={()=>{handleDelete(row.trackid)}}><DeleteIcon /></Button></StyledTableCell>

                    </StyledTableRow>
                  ))}
                  <StyledTableRow  sx={{
                                position: "sticky",
                                bottom: 0,
                               backgroundColor: "#A7C7E7 !important",
                                zIndex: 2, // Ensures it stays above the content
                              }}>
                  <StyledTableCell  align="center" style={{fontSize:"1rem"}} colSpan={2}><strong>Total</strong></StyledTableCell>
                  <StyledTableCell align="center"  style={{fontSize:"1rem"}}><strong>{Number(submitValue.p_details.reduce((total, row) => {const amt = parseFloat(row.yearAmount);
                  return total + (isNaN(amt) ? 0 : amt);}, 0)).toFixed(2)}</strong></StyledTableCell>
                  <StyledTableCell align="center"  style={{fontSize:"1rem"}}><strong>{Number(submitValue.p_details.reduce((total, row) => {const amt = parseFloat(row.suspenseAmount);
                  return total + (isNaN(amt) ? 0 : amt);}, 0)).toFixed(2)}</strong></StyledTableCell>
                  <StyledTableCell align="center"  style={{fontSize:"1rem"}}><strong>{Number(submitValue.p_details.reduce((total, row) => {const amt = parseFloat(row.amount);
                  return total + (isNaN(amt) ? 0 : amt);}, 0)).toFixed(2)}</strong></StyledTableCell>
                  <StyledTableCell colSpan={2}></StyledTableCell>
                    </StyledTableRow>
                </TableBody>
                
              </Table>
            </TableContainer>
            </Paper>
              :
                               
              null  
            }
            </Grid>
            :
            null
          }




      <Grid item xs={12} md={12} style={{margin:"10px 50px 10px 50px",boxShadow:"2px 2px 2px 2px gray",padding:"20px",border:"2px solid slateblue",borderRadius:"5px"}}>
      <div style={{marginBottom:"5px",textAlign:"left",color:"slateblue"}}><h2>Settlement Information</h2></div>
      <TextField
                    select
                    fullWidth
                    required
                    
                    name="p_accounttype"
                    {...register("p_accounttype", { required: true })}
                    label="Select Account Type"
                    variant="outlined"
                    className="input-field"
                    defaultValue={2}
                    onChange={handleChangeAccountType}
                    style={{ margin: "3px" }}
                  >
                    {accounts.map((option, index) => (
                      <MenuItem
                        key={index}
                        value={option.id}
                        style={{ fontSize: 13,fontWeight:"bold" }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
              </TextField>  
              
      
      {
        AccountTypeId == 1
        ?
        <div>
          <TextField fullWidth  variant="outlined" type="text" name="p_sholdername" label="Second Name" value={submitValue.p_sholdername}  style={{ margin: "5px 0", width: "100%" }}
          onChange={(e)=>{
            setSubmitValue(prevState => ({
              ...prevState,
              p_sholdername : e.target.value
            }));
          }}
          required = {AccountTypeId===1}
          />
          <Grid container spacing ={2}>
          <Grid item lg={6} md={6} sm={12} xs={12} >
          
      <TextField
                fullWidth
                variant="outlined"
                type="text"
                name="p_sholdernid"
                label="Second NID"
                style={{ margin: "5px 0", width: "100%" }}
                value={submitValue.p_sholdernid}
                onChange={(e) => {
                  let value = e.target.value.replace(/\D/g, ""); // digits only

                  // Limit to 17 digits
                  if (value.length > 17) {
                    value = value.slice(0, 17);
                  }
                  setSubmitValue((prevState) => ({
                    ...prevState,
                    p_sholdernid: value,
                  }));

                  // Validate
                   if (value && ![10, 13, 17].includes(value.length)) {
                    setSholderNidError("NID must be 10, 13, or 17 digits");
                  } else {
                    setSholderNidError("");
                  }
                }}
                inputProps={{
                  inputMode: "numeric", // mobile numeric keyboard
                  pattern: "\\d*",
                  maxLength: 17,
                }}
                error={!!sholdernidError}
                helperText={sholdernidError && <span style={{ color: "red" }}>{sholdernidError}</span>}
              />


          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12} >
          <TextField fullWidth variant="outlined"  type="text" name="p_sholderpassport" value={submitValue.p_sholderpassport} label="Second Passport" style={{ margin: "5px 0", width: "100%" }} 
          onChange={(e)=>{
            setSubmitValue(prevState => ({
              ...prevState,
              p_sholderpassport: e.target.value
            }));
          }} />
          </Grid></Grid>
          </div>
          :
          null
      }
<Grid container spacing ={2}>
<Grid item lg={6} md={6} sm={12} xs={12} >
      <Controller
              name="p_applicationdate"
              control={control}
              render={({ field: { onChange, value } })  => (
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-gb'}>
                  <DatePicker sx={{margin:"3px",width:"100%"}}
                  label="Application Date"
                  disableFuture
                  value={value ? dayjs(value) : null} 
                  {...register("p_applicationdate")}
                    onChange={(date) => {
                      date = date ? date.format("YYYY/MM/DD") : "";
                    onChange(date);
                    setSubmitValue(prevState => ({
                      ...prevState,
                      p_applicationdate:date
                    }));
                  }
                    
                    
                      }
                    renderInput={(params) => (
                      <TextField
                        
                        fullWidth
                        {...params}
                        required
                        label="Application Date"
                        variant="outlined"
                        style={{ margin: "5px" }}
                      />
                    )}
                  />
                </LocalizationProvider>
              )}
            />
            {submitValue.p_applicationdate === "" && (
                              <span style={{ color: "red" }}>Application Date required</span>
                            )}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12} >
            <Controller
              name="p_claimrecieveddate"
              control={control}
              render={({ field: { onChange, value } })  => (
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-gb'}>
                  <DatePicker sx={{margin:"3px",width:"100%"}}
                  label="Claim Recieved Date"
                  disableFuture
                  value={value ? dayjs(value) : null} 
                  {...register("p_claimrecieveddate")}
                    onChange={(date) => {
                      date = date ? date.format("YYYY/MM/DD") : "";
                    onChange(date);
                    setSubmitValue(prevState => ({
                      ...prevState,
                      p_claimrecieveddate:date
                    }));
                  }
                      }
                    renderInput={(params) => (
                      <TextField
                        required
                        fullWidth
                        {...params}
                        label="Claim Recieved Date"
                        variant="outlined"
                        style={{ margin: "5px" }}
                      />
                    )}
                  />
                </LocalizationProvider>
              )}
            />
            {submitValue.p_claimrecieveddate === "" && (
                              <span style={{ color: "red" }}>Claim Recieved Date required</span>
                            )}
</Grid></Grid>
              <TextField
                    select
                    fullWidth
                    required
                    
                    name="p_settlementstatus"
                    {...register("p_settlementstatus", { required: true })}
                    label="Select Settlement Status"
                    variant="outlined"
                    className="input-field"
                    value={submitValue.p_settlementstatus}
                    onChange={handleChangeSettlementStatus}
                    style={{ margin: "3px" }}
                  >
                    {settlementstatus.map((option, index) => (
                      <MenuItem
                        key={index}
                        value={option.id}
                        style={{ fontSize: 13,fontWeight:"bold" }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
              </TextField> 
              {submitValue.p_settlementstatus < 1 && (
                              <span style={{ color: "red" }}>Settlement status required</span>
                            )}
      

               



                  <Grid container spacing ={2}>
                  <Grid item lg={6} md={6} sm={12} xs={12} >
                  <Controller
                      name="p_investordividendtypeid"
                      control={control}
                      render={({ field, fieldState: { error } }) => {
                        const { onChange, value, ref } = field;
                        return (
                          <>
                            <Autocomplete
                                value={
                                  value
                                    ? dividendType.find((option) => option.id === value) ?? null
                                    : null
                                }
                                disableClearable
                                getOptionLabel={(option) => `${option.investorDividendType} (${option.dividendType})`}
                                onChange={(event, data) => {
                                  // Update form value using onChange
                                  onChange(data ? data.id : "");  // Update value for Controller

                                  // Update the state with additional fields
                                  if (data) {
                                    setSelectedDividendType(data.dividendType);
                                    getSettlementSerial(data.dividendType)
                                    // if(data.dividendType === "Stock") {
                                    // setTimeout(() => {
                                    //             getSelectedDpHouse(submitValue.p_boid);
                                    //           }, 0);

                                    // }
                                    setBankList([]);
                                    setDPList([]);
                                    getBankList();
                                    getdplist();
                                    setSelectedBank("0");
                                    setSelectedBranch("0");
                                    setSelectedHouse(0);
                                    // console.log(data.id);
                                    setSubmitValue(prevState => ({
                                      ...prevState,
                                      p_investordividendtypeid: data.id,
                                      p_bankName:"",
                                      p_bank_id:"",
                                      p_routingNo:"",
                                      p_dp_id:0
                                    }));
                                  } 
                                }}
                                options={dividendType}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    required
                                    label={"Select Investor Dividend Type"}
                                    inputRef={ref}
                                    error={!!error}
                                    style={{margin:"4px",}}
                                    helperText={error ? error.message : ""}
                                    
                                  />
                                )}
                              />
                           {submitValue.p_investordividendtypeid < 1 && (
                              <span style={{ color: "red" }}>Investor Dividend type required</span>
                            )}
                          </>
                        );
                      }}
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}  >
                  <TextField
                    select
                    fullWidth
                    required
                    defaultValue={0}
                    label="Select Suspense / Untraceable / BEFTN Return"
                    
                    variant="outlined"
                    className="input-field"
                    onChange={handleChangeSuspense}
                    style={{ margin: "5px 0"}}
                  >
                      <MenuItem value={1}> Yes </MenuItem>
                      <MenuItem value={0}>No</MenuItem>
              </TextField> 
                  </Grid>
                  
                </Grid>
                  
                    {
        settlementStatus == 2
        ?
        <>
        <Grid container spacing ={2}>
        <Grid item lg={6} md={6} sm={12} xs={12} >
        {/* <TextField required fullWidth type="number" variant="outlined" label="Settlement Serial ID" style={{ margin: "3px" }}
         {...register("p_settlementserialid", {required: settlementStatus===2 ? true : false})}
         onChange={(e)=>{
          setSubmitValue(prevState => ({
            ...prevState,
            p_settlementserialid:e.target.value
          }));
        }}
                  /> */}
                  <Controller
                      name="p_settlementserialid"
                      control={control}
                      render={({ field, fieldState: { error } }) => {
                        const { onChange, value, ref } = field;
                        return (
                          <>
                            <Autocomplete
                                value={
                                  value
                                    ? settlementSerial.find((option) => option.settlementno === value) ?? null
                                    : null
                                }
                                disableClearable
                                getOptionLabel={(option) => `${option.settlementno}`}
                                onChange={(event, data) => {
                                  const settlementDate = data.settlementdate;
                                  const formattedDate = dayjs(settlementDate).format("YYYY/MM/DD");
                                  
                                  onChange(data ? data.settlementno : "");  // Update value for Controller
                                    setSubmitValue(prevState => ({
                                      ...prevState,
                                      p_settlementserialid:data.settlementno,
                                      p_settlementdate: formattedDate
                                    }));
                                   // Update form value using onChange                                         
                                }}
                                options={settlementSerial}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    required
                                    
                                    label={"Select Settlement Serial No"}
                                    inputRef={ref}
                                    error={!!error}
                                    style={{margin:"4px",}}
                                    helperText={error ? error.message : ""}
                                  />
                                )}
                              />
                           {submitValue.p_settlementserialid ==="" && (
                              <span style={{ color: "red" }}>Settlement No required</span>
                            )}
                          </>
                        );
                      }}
                    />
                  
      </Grid>
      <Grid item lg={6} md={6} sm={12} xs={12} >
      {/* <Controller
              name="p_settlementdate"
              control={control}
              render={({ field: { onChange, value } })  => (
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-gb'}>
                  <DatePicker  sx={{margin:"3px",width:"100%"}}
                  required= {settlementStatus==2 ? true : false}
                  label="Settlement Date"
                  disableFuture
                  value={value ? dayjs(value) : submitValue.p_settlementdate ? dayjs(submitValue.p_settlementdate) : null} 
                  // {...register("p_settlementdate", { required: settlementStatus==2 ? true : false })}
                  
                    onChange={(date) => {
                      date = date ? date.format("YYYY/MM/DD") : "";
                      setSubmitValue(prevState => ({
                      ...prevState,
                      p_settlementdate: date
                    }))
                    onChange(date);
                  
                  }
                    
                    
                      }
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        {...params}
                        label="Settlement Date"
                        variant="outlined"
                        style={{ margin: "5px" }}
                        value={submitValue.p_settlementdate ? dayjs(submitValue.p_settlementdate) : null}
                      />
                    )}
                  />
                </LocalizationProvider>
              )}
            /> */}
            <TextField required fullWidth  type="text" value={submitValue.p_settlementdate} variant="outlined" label="Settlement Date" style={{ margin: "3px" }} readOnly/>
            {submitValue.p_settlementdate === "" && (
                              <span style={{ color: "red" }}>Settlement Date required</span>
                            )}
      </Grid>
      </Grid>
            </>
            :
            null
            
} 
    
          {
              selectedDividendType ==="Cash"
              ?
              <>
               <Controller
                      name="p_bankName"
                      control={control}
                      rules={{
                        required: settlementStatus === 2 ? "Please Select a BankName" : false
                      }}
                      render={({ field, fieldState: { error } }) => {
                        const { onChange, value, ref } = field;
                        return (
                          <>
                            <Autocomplete
                                value={
                                  value
                                    ? bankList.find((option) => option.bankName === value) ?? null
                                    : null
                                }
                                getOptionLabel={(option) => option.bankName || ""}  // Use the correct key (bankName) for display
                                onChange={(event, data) => {
                                  // Update form value using onChange
                                  onChange(data ? data.bankName : "");  // Update value for Controller

                                  // Update the state with additional fields
                                  if (data) {
                                    // console.log(data);
                                    setSubmitValue((prevState) => ({
                                      ...prevState,
                                      p_bankName: data.bankName,
                                      p_bank_id: "",  // Reset other fields
                                      p_routingNo: "",
                                      p_dp_id: 0
                                    }));
                                    setSelectedBank(data.bankName);
                                    setBranchList([]);
                                    resetField("p_bank_id");
                                    getBranchList(data.bankName);
                                  } else {
                                    setSubmitValue((prevState) => ({
                                      ...prevState,
                                      p_bankName: "",
                                      p_bank_id: "",
                                      p_routingNo: "",
                                      p_dp_id: 0
                                    }));
                                    setSelectedBank("");
                                    resetField("p_bank_id");
                                  }
                                }}
                                options={bankList}
                                renderInput={(params) => (
                                  <TextField
                                  style={{margin:"5px 0"}}
                                    {...params}
                                    label={"Select a Bank"}
                                    required
                                    inputRef={ref}
                                    error={!!error}
                                    helperText={error ? error.message : ""}
                                  />
                                )}
                              />
                            {submitValue.p_bankName === "" && (
                              <span style={{ color: "red" }}>Bank required</span>
                            )}
                          </>
                        );
                      }}
                    />
      {
                      selectedBank !=="0" ?
                      <>
                      <Grid container spacing ={2}>
                      <Grid item lg={6} md={6} sm={12} xs={12} >
                      {
                        branchList.length > 0
                        ?
                        <Controller
                            name="p_bank_id"
                            control={control}
                            {...register("p_bank_id")}
                            rules={{
                              required: selectedBank !== "" ? "Please Select a Branch Name" : false
                            }}
                            render={({ field, fieldState: { error } }) => {
                              const { onChange, value, ref } = field;
                              return (
                                <>
                                  <Autocomplete
                                      value={
                                        value
                                          ? branchList.find((option) => option.id === value) ?? null
                                          : null
                                      }
                                      getOptionLabel={(option) => `${option.branchName} - ${option.routingNo}` || ""} // Use the correct key (bankName) for display
                                      onChange={(event, data) => {
                                        // Update form value using onChange
                                        onChange(data ? data.id : "");  // Update value for Controller

                                        // Update the state with additional fields
                                        if (data) {
                                          setSubmitValue((prevState) => ({
                                            ...prevState,
                                            p_bank_id: data.id,
                                            p_routingNo: data.routingNo,
                                            p_dp_id: 0
                                          }));
                                        }
                                      }}
                                      options={branchList}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={"Select a Branch"}
                                          
                                          style={{ margin: "5px 0", width: "100%" }}
                                          inputRef={ref}
                                          error={!!error}
                                          helperText={error ? error.message : ""}
                                        />
                                      )}
                                    />
                                  {submitValue.p_bank_id === "" && (
                              <span style={{ color: "red" }}>Branch required</span>
                            )}
                                </>
                          
                              );
                            }}
                          />
                        :
                        <div style={{display: "flex", justifyContent: "center", alignItems: "center",}}>
                        <Triangle
                          visible={true}
                          height="60"
                          width="60"
                          color="#0275d8"
                          textAlign="center"
                          // wrapperStyle={{ padding: 'auto auto'}}
                          ariaLabel="triangle-loading"
                          wrapperClass=""
                          />
                          </div>
                      } 
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12} >
                    {/* <TextField name="p_routingNo"
                  fullWidth variant="outlined" 
                  focused
                  label="Routing No" 
                  style={{ margin: "5px" }}
                  value={submitValue.p_routingNo}

                {...register("p_routingNo")}
                /> */}
                <TextField name="p_account_no"
                 {...register("p_account_no")}
                  required={selectedBank !== "" || selectedBank !== null  ? true : false} 
                  fullWidth variant="outlined" 
                  label="Account No" 
                  
                  style={{ margin: "5px"}}
                  onChange={(e)=>{
                    setSubmitValue(prevState => ({
                      ...prevState,
                      p_account_no:e.target.value
                    }));
                  }}
               
                />
                {submitValue.p_account_no === "" && (
                              <span style={{ color: "red" }}>Bank Account required</span>
                            )}
                </Grid></Grid>

              </>
                    :
                    null
        }
              </>
              :
              selectedDividendType ==="Stock"
              ?
                <>
                <Grid container spacing ={2}>
                <Grid item lg={6} md={6} sm={12} xs={12} >
                    <Controller
                      name="p_dp_id"
                      control={control}
                      rules={{
                        required: settlementStatus === 2 ? "Please Select a DP House" : false
                      }}
                      render={({ field, fieldState: { error } }) => {
                        const { onChange, value, ref } = field;
                        return (
                          <>
                            <Autocomplete
                                value={
                                  value
                                    ? dpList.find((option) => option.id === value) ?? null
                                    : null
                                }
                                getOptionLabel={(option) => `${option.dpName} (${option.dpId})` || ""}  // Use the correct key (bankName) for display
                                onChange={(event, data) => {
                                  onChange(data ? data.id : "");
                                  if (data) {
                                    setSubmitValue((prevState) => ({
                                      ...prevState,
                                      p_bankName: "",
                                      p_bank_id: "",
                                      p_routingNo: "",
                                      p_dp_id: data.id
                                    }));
                                  } else {
                                    setSubmitValue((prevState) => ({
                                      ...prevState,
                                      p_bankName: "",
                                      p_bank_id: "",
                                      p_routingNo: "",
                                      p_dp_id: 0
                                    }));
                                  }
                                }}
                                options={dpList}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={"Select a DP House"}
                                    required
                                    style={{ margin: "5px"}}
                                    inputRef={ref}
                                    error={!!error}
                                    helperText={error ? error.message : ""}
                                  />
                                )}
                              />
                            {submitValue.p_dp_id < 1 && (
                              <span style={{ color: "red" }}>DP House required</span>
                            )}
                          </>
                        );
                      }}
                    />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12} >
                     <TextField name="p_stock_unit_price"
                  // required={selectedHouse >0 || selectedHouse < 0  ? true : false} 
                  fullWidth variant="outlined" 
                  
                  label="Stock Unit Price" 
                  style={{  width: "100%",margin:"5px" }}
                  onChange={(e)=>{
                    setSubmitValue(prevState => ({
                      ...prevState,
                      p_stock_unit_price:e.target.value
                    }));
                  }}
                      {...register("p_stock_unit_price")}
                      />
                      {/* {submitValue.p_stock_unit_price < 1 && (
                              <span style={{ color: "red" }}>Stock Unit Price required</span>
                            )} */}
                      </Grid></Grid>
                </>
                :
                null
          }

              <div style={{width:"100%",padding:"10px",margin:"5px"}}>

              {/* <h4>Documents Upload (Maximum Limit 2 MB) : </h4>
              <Grid container spacing={2}>
              <Grid item lg={6} md={6} sm={12} xs={12} for="pdfupload"  style={{border:"1px dashed gray"}}> <label
                                for="pdfupload"
                                style={{ color: "black", fontWeight: "bold",border:"1px solid green" }}
                                className="btn btn-warning btn-lg"
                                >Upload PDF File <BackupIcon style={{fill:'black'}} /></label>
                                <input
                                required
                                  id="pdfupload"
                                  name="csvFile"
                                  type="file"
                                  onChange={(e)=>{
                                      handleFileUploadPDF(e);
                                  }}
                                  style={{ display: "none",visibility:"none" }}
                                />
                                {submitValue.folio_bo_file ? 
                                <>
                                <button className="btn btn-danger btn-lg" type="button" style={{color:"white", border:"2px solid black", marginLeft:"2px"}}
                                onClick={()=>{
                                  Swal.fire({
                                    icon: 'question',
                                    title: 'Are you sure about removing the file selected?',
                                    showConfirmButton: true,
                                    confirmButtonText: 'Yes',
                                    showCancelButton: true,
                                    cancelButtonText: "No",
                                  }).then((res)=>{
                                    if(res.isConfirmed)
                                    {
                                      setSubmitValue( prevValues => {
                                        return { ...prevValues,folio_bo_file: ""}
                                      })
                                    }
                                  })
                                }}
                                >X</button>
                                <h4>{submitValue.folio_bo_file?.name}</h4> 
                                <h5>{Math.round(submitValue.folio_bo_file?.size/1024)} KB </h5> 
                                
                                </>
                                : null}
                                </Grid>
                                {open && handleOpenPreview()}
                          <Grid item lg={6} md={6} sm={12} xs={12} style={{border:"1px dashed gray"}}>
                          
                            <button className="btn btn-primary btn-lg" type="button" style={{color:"white",border:"1px solid black"}} onClick={()=>{setOpen(true);}}><RemoveRedEyeIcon/>Preview Uploaded PDF</button>
                                  {open && handleOpenPreview()}
                          </Grid>
                                </Grid> */}
                                <PdfUpload submitValue = {submitValue} setSubmitValue={setSubmitValue} />
                                
                                        
              </div>

                
                <TextField
                name="p_remarks"
                  fullWidth
                  variant="outlined"
                  multiline
                  rows={2}
                  
                  label="Remarks"
                  style={{ margin: "5px" }}
                  onChange={(e)=>{
                    setSubmitValue(prevState => ({
                      ...prevState,
                      p_remarks:e.target.value
                    }));
                  }}
                  {...register("p_remarks")}
                />
                </Grid>
      </Grid>
          
      
            <div>
              <FormControlLabel control={<Checkbox defaultChecked={isRemember} onChange={handleIsRememeber}/>} label="Click to remember current informations"/>
              

            </div>
                <Box  display="flex" justifyContent="center" mt={2} sx={{ width: '100%' }}>
                <Button fullWidth={isSmallScreen} type="submit" sx={{padding:"10px",width: isSmallScreen ? '50%' :'25%' }} color="primary" variant="contained"  startIcon={<DoneAllIcon />}>SAVE INFORMATIONS </Button>
              </Box>

                              
            </form>
      </Grid>
          }

    </React.Fragment>
  );
}

export default DividendSettlement
// 
// merge with Labir - 2